import React from 'react';

const CrossIconDesktop: React.FC<{ color?: string }> = ({ color }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.9428 8.94265C25.4635 8.42195 25.4635 7.57773 24.9428 7.05703C24.4221 6.53633 23.5779 6.53633 23.0572 7.05703L16 14.1142L8.9428 7.05703C8.4221 6.53633 7.57788 6.53633 7.05718 7.05703C6.53648 7.57773 6.53648 8.42195 7.05718 8.94265L14.1144 15.9998L7.05718 23.057C6.53648 23.5777 6.53648 24.4219 7.05718 24.9426C7.57788 25.4633 8.4221 25.4633 8.9428 24.9426L16 17.8855L23.0572 24.9426C23.5779 25.4633 24.4221 25.4633 24.9428 24.9426C25.4635 24.4219 25.4635 23.5777 24.9428 23.057L17.8856 15.9998L24.9428 8.94265Z"
        fill={color ?? '#212121'}
      />
    </svg>
  );
};

export default CrossIconDesktop;
